(function(){
  'use strict';

  /* === Enable smooth scroll after first paint === */
  requestAnimationFrame(function() {
    document.documentElement.classList.add('smooth');
  });

  /* === Announcement bar rotation === */
  var slides = document.querySelectorAll('.announcement-slide');
  if (slides.length > 1) {
    var idx = 0;
    slides[0].classList.add('active');
    setInterval(function() {
      slides[idx].classList.remove('active');
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add('active');
    }, 5000);
  } else if (slides.length === 1) {
    slides[0].classList.add('active');
  }

  /* === Header scroll effect === */
  var header = document.querySelector('.header');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          header.classList.toggle('scrolled', scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* === Mobile menu === */
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  var menuEl = document.querySelector('.mobile-menu');
  var overlayEl = document.querySelector('.mobile-overlay');

  function openMenu() {
    if (menuEl) menuEl.classList.add('open');
    if (overlayEl) overlayEl.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }
  function closeMenu() {
    if (menuEl) menuEl.classList.remove('open');
    if (overlayEl) overlayEl.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (openBtn) openBtn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlayEl) overlayEl.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (menuEl && menuEl.classList.contains('open')) closeMenu();
      if (typeof closeAllMega === 'function') closeAllMega();
      document.querySelectorAll('.popup-bg.active, .date-popup-bg.active').forEach(function(p) { p.classList.remove('active'); });
    }
  });
  if (menuEl) {
    menuEl.querySelectorAll('.mobile-nav-pages a, .mobile-cat-links a').forEach(function(a) {
      a.addEventListener('click', closeMenu);
    });
  }

  /* === Mobile category toggles === */
  document.querySelectorAll('[data-mobile-cat]').forEach(function(cat) {
    var toggle = cat.querySelector('.mobile-cat-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function() {
      var wasOpen = cat.classList.contains('open');
      document.querySelectorAll('[data-mobile-cat].open').forEach(function(c) {
        c.classList.remove('open');
      });
      if (!wasOpen) cat.classList.add('open');
    });
  });

  /* === Accordions === */
  document.querySelectorAll('.accordion-trigger').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.accordion-item');
      if (!item) return;
      var acc = item.closest('.accordion');
      if (acc && !acc.dataset.multi) {
        acc.querySelectorAll('.accordion-item.open').forEach(function(i) {
          if (i !== item) i.classList.remove('open');
        });
      }
      item.classList.toggle('open');
    });
  });

  /* === CET date helper === */
  function todayCET() {
    var now = new Date();
    var cet = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    return new Date(cet.getFullYear(), cet.getMonth(), cet.getDate());
  }

  function dateStr(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }

  function parseDate(s) {
    var p = s.split('-');
    return new Date(parseInt(p[0]), parseInt(p[1]) - 1, parseInt(p[2]));
  }

  function isSameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }

  function daysBetween(a, b) {
    var ms = b.getTime() - a.getTime();
    return Math.max(1, Math.round(ms / 86400000) + 1);
  }

  var MONTHS_NL = ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'];
  var DAYS_NL = ['Ma','Di','Wo','Do','Vr','Za','Zo'];

  /* === Calendar date picker === */
  var calPopupBg = document.querySelector('#date-popup');
  var calContainer = document.querySelector('#cal-container');
  var dateTrigger = document.querySelector('.date-trigger');
  var sameDayPopup = document.querySelector('#same-day-popup');
  var inputFrom = document.querySelector('#date-from');
  var inputTo = document.querySelector('#date-to');
  var qtyInput = document.querySelector('#rental-qty');
  var priceTotal = document.querySelector('#price-total');
  var priceDays = document.querySelector('#price-days');
  var priceBase = document.querySelector('#price-base');
  var submitBtn = document.querySelector('#add-to-cart-btn');

  var unitPrice = 0;
  var priceEl = document.querySelector('[data-unit-price]');
  if (priceEl) unitPrice = parseFloat(priceEl.getAttribute('data-unit-price')) || 0;

  var selectState = { from: null, to: null, step: 'from' };
  var calMonth, calYear, minDate;
  var monthYearPickerOpen = false;

  function initCalendar() {
    if (!calContainer) return;
    minDate = todayCET();
    calMonth = minDate.getMonth();
    calYear = minDate.getFullYear();
    renderCalendar();
  }

  function renderCalendar() {
    if (!calContainer) return;

    var firstDay = new Date(calYear, calMonth, 1);
    var lastDay = new Date(calYear, calMonth + 1, 0);
    var startWeekday = (firstDay.getDay() + 6) % 7;

    var html = '<div class="cal-header">';
    html += '<button type="button" class="cal-nav cal-prev" aria-label="Vorige maand"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>';
    html += '<button type="button" class="cal-title cal-title-btn" aria-label="Kies maand en jaar">' + MONTHS_NL[calMonth] + ' ' + calYear + '</button>';
    html += '<button type="button" class="cal-nav cal-next" aria-label="Volgende maand"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></button>';
    html += '</div>';

    html += '<div class="cal-grid">';
    for (var i = 0; i < 7; i++) {
      html += '<div class="cal-day-name">' + DAYS_NL[i] + '</div>';
    }

    for (var e = 0; e < startWeekday; e++) {
      html += '<div class="cal-cell cal-empty"></div>';
    }

    for (var d = 1; d <= lastDay.getDate(); d++) {
      var thisDate = new Date(calYear, calMonth, d);
      var iso = dateStr(thisDate);
      var cls = 'cal-cell cal-day';
      var disabled = thisDate < minDate;

      if (disabled) cls += ' cal-disabled';
      if (isSameDay(thisDate, todayCET())) cls += ' cal-today';

      if (selectState.from && isSameDay(thisDate, selectState.from)) cls += ' cal-selected cal-range-start';
      if (selectState.to && isSameDay(thisDate, selectState.to)) cls += ' cal-selected cal-range-end';
      if (selectState.from && selectState.to && thisDate > selectState.from && thisDate < selectState.to) cls += ' cal-in-range';

      html += '<button type="button" class="' + cls + '" data-date="' + iso + '"' + (disabled ? ' disabled' : '') + '>' + d + '</button>';
    }

    html += '</div>';

    html += '<div class="cal-footer">';
    html += '<div class="cal-selection">';
    if (selectState.from) {
      html += '<span class="cal-sel-label">Van: <strong>' + formatDateNL(selectState.from) + '</strong></span>';
    }
    if (selectState.to) {
      var days = daysBetween(selectState.from, selectState.to);
      html += '<span class="cal-sel-label">Tot: <strong>' + formatDateNL(selectState.to) + '</strong></span>';
      html += '<span class="cal-sel-days">' + days + ' ' + (days === 1 ? 'dag' : 'dagen') + '</span>';
      if (unitPrice > 0) {
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        var previewTotal = unitPrice * days * qty;
        html += '<span class="cal-sel-price">' + days + ' × \u20AC' + unitPrice.toFixed(2).replace('.', ',');
        if (qty > 1) html += ' × ' + qty;
        html += ' = \u20AC' + previewTotal.toFixed(2).replace('.', ',') + '</span>';
      }
    }
    if (!selectState.from) {
      html += '<span class="cal-sel-hint">Kies een startdatum</span>';
    } else if (!selectState.to) {
      html += '<span class="cal-sel-hint">Kies een einddatum</span>';
    }
    html += '</div>';
    html += '<button type="button" class="btn btn-accent btn-full cal-confirm-btn"' + (!selectState.from || !selectState.to ? ' disabled' : '') + '>Bevestigen</button>';
    html += '</div>';

    /* Month/Year picker overlay */
    html += '<div class="cal-my-picker" id="cal-my-picker" style="display:none">';
    html += '<div class="cal-my-picker-inner">';
    html += '<div class="cal-my-col">';
    html += '<div class="cal-my-label">Maand</div>';
    html += '<div class="cal-my-scroll" id="cal-month-scroll">';
    for (var mi = 0; mi < 12; mi++) {
      html += '<button type="button" class="cal-my-opt' + (mi === calMonth ? ' active' : '') + '" data-month="' + mi + '">' + MONTHS_NL[mi] + '</button>';
    }
    html += '</div>';
    html += '</div>';
    html += '<div class="cal-my-col">';
    html += '<div class="cal-my-label">Jaar</div>';
    html += '<div class="cal-my-scroll" id="cal-year-scroll">';
    var currentYear = todayCET().getFullYear();
    for (var yi = currentYear; yi <= currentYear + 5; yi++) {
      html += '<button type="button" class="cal-my-opt' + (yi === calYear ? ' active' : '') + '" data-year="' + yi + '">' + yi + '</button>';
    }
    html += '</div>';
    html += '</div>';
    html += '</div>';
    html += '<button type="button" class="btn btn-primary btn-full btn-sm cal-my-confirm" style="margin-top:.75rem">Selecteer</button>';
    html += '</div>';

    calContainer.innerHTML = html;

    /* Navigation */
    calContainer.querySelector('.cal-prev').addEventListener('click', function() {
      calMonth--;
      if (calMonth < 0) { calMonth = 11; calYear--; }
      renderCalendar();
    });
    calContainer.querySelector('.cal-next').addEventListener('click', function() {
      calMonth++;
      if (calMonth > 11) { calMonth = 0; calYear++; }
      renderCalendar();
    });

    /* Month/Year picker toggle */
    var titleBtn = calContainer.querySelector('.cal-title-btn');
    var myPicker = calContainer.querySelector('#cal-my-picker');
    if (titleBtn && myPicker) {
      titleBtn.addEventListener('click', function() {
        var isVisible = myPicker.style.display !== 'none';
        myPicker.style.display = isVisible ? 'none' : 'block';
        if (!isVisible) {
          var activeMonth = myPicker.querySelector('#cal-month-scroll .active');
          var activeYear = myPicker.querySelector('#cal-year-scroll .active');
          if (activeMonth) activeMonth.scrollIntoView({ block: 'center', behavior: 'smooth' });
          if (activeYear) activeYear.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    }

    /* Month/Year option clicks */
    var tempMonth = calMonth;
    var tempYear = calYear;

    calContainer.querySelectorAll('#cal-month-scroll .cal-my-opt').forEach(function(btn) {
      btn.addEventListener('click', function() {
        calContainer.querySelectorAll('#cal-month-scroll .cal-my-opt').forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        tempMonth = parseInt(this.dataset.month);
      });
    });

    calContainer.querySelectorAll('#cal-year-scroll .cal-my-opt').forEach(function(btn) {
      btn.addEventListener('click', function() {
        calContainer.querySelectorAll('#cal-year-scroll .cal-my-opt').forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        tempYear = parseInt(this.dataset.year);
      });
    });

    var myConfirm = calContainer.querySelector('.cal-my-confirm');
    if (myConfirm) {
      myConfirm.addEventListener('click', function() {
        calMonth = tempMonth;
        calYear = tempYear;
        renderCalendar();
      });
    }

    /* Day click — supports backward selection for full range */
    calContainer.querySelectorAll('.cal-day:not(.cal-disabled)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var picked = parseDate(this.getAttribute('data-date'));
        if (selectState.step === 'from') {
          selectState.from = picked;
          selectState.to = null;
          selectState.step = 'to';
        } else {
          if (picked < selectState.from) {
            selectState.to = selectState.from;
            selectState.from = picked;
          } else if (isSameDay(picked, selectState.from)) {
            selectState.to = picked;
          } else {
            selectState.to = picked;
          }
          selectState.step = 'from';
        }
        renderCalendar();
      });
    });

    var confirmBtn = calContainer.querySelector('.cal-confirm-btn');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        if (!selectState.from || !selectState.to) return;
        if (inputFrom) inputFrom.value = dateStr(selectState.from);
        if (inputTo) inputTo.value = dateStr(selectState.to);
        updateTriggerDisplay();
        updatePrice();
        if (calPopupBg) calPopupBg.classList.remove('active');

        if (isSameDay(selectState.from, todayCET()) && sameDayPopup) {
          sameDayPopup.classList.add('active');
        }
      });
    }
  }

  function formatDateNL(d) {
    var months = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function formatDateShort(d) {
    var months = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
    return d.getDate() + ' ' + months[d.getMonth()];
  }

  function updateTriggerDisplay() {
    if (!dateTrigger) return;
    var fromEl = dateTrigger.querySelector('.from-val');
    var toEl = dateTrigger.querySelector('.to-val');
    if (fromEl) fromEl.textContent = selectState.from ? formatDateShort(selectState.from) : 'Kies datum';
    if (toEl) toEl.textContent = selectState.to ? formatDateShort(selectState.to) : 'Kies datum';
    if (selectState.from && selectState.to) dateTrigger.classList.add('has-value');
    else dateTrigger.classList.remove('has-value');
  }

  function updatePrice() {
    var rentalTotalEl = document.querySelector('.rental-total');
    if (!selectState.from || !selectState.to || !unitPrice) {
      if (rentalTotalEl) rentalTotalEl.style.display = 'none';
      if (submitBtn) {
        var btnPrice = submitBtn.querySelector('.btn-price');
        if (btnPrice) btnPrice.textContent = '';
      }
      return;
    }
    var days = daysBetween(selectState.from, selectState.to);
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    var total = unitPrice * days * qty;

    if (priceDays) priceDays.textContent = days + ' ' + (days === 1 ? 'dag' : 'dagen');

    var breakdownEl = document.querySelector('#price-breakdown');
    if (breakdownEl) {
      var breakdown = days + ' ' + (days === 1 ? 'dag' : 'dagen') + ' × \u20AC' + unitPrice.toFixed(2).replace('.', ',');
      if (qty > 1) breakdown += ' × ' + qty + ' stuks';
      breakdownEl.textContent = breakdown;
    }

    if (priceTotal) {
      priceTotal.textContent = '\u20AC' + total.toFixed(2).replace('.', ',');
      if (rentalTotalEl) rentalTotalEl.style.display = '';
    }
    if (submitBtn) {
      var btnPriceEl = submitBtn.querySelector('.btn-price');
      if (btnPriceEl) btnPriceEl.textContent = ' \u2014 \u20AC' + total.toFixed(2).replace('.', ',');
    }

    var hiddenDays = document.querySelector('#rental-days');
    var hiddenSubtotal = document.querySelector('#rental-subtotal');
    var hiddenActualQty = document.querySelector('#rental-actual-qty');
    if (hiddenDays) hiddenDays.value = days + ' ' + (days === 1 ? 'dag' : 'dagen');
    if (hiddenActualQty) hiddenActualQty.value = qty;
    if (hiddenSubtotal) hiddenSubtotal.value = '\u20AC' + total.toFixed(2).replace('.', ',');
  }

  /* === Intercept form submission: use Cart AJAX API so Shopify charges correctly === */
  var productForm = submitBtn ? submitBtn.closest('form') : null;
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      if (!selectState.from || !selectState.to) {
        if (dateTrigger) {
          dateTrigger.style.outline = '2px solid var(--red, #e53e3e)';
          dateTrigger.style.outlineOffset = '2px';
          setTimeout(function() { dateTrigger.style.outline = ''; dateTrigger.style.outlineOffset = ''; }, 2000);
        }
        return;
      }

      var days = daysBetween(selectState.from, selectState.to);
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var totalQty = days * qty;
      var variantId = productForm.querySelector('input[name="id"]').value;

      var properties = {};
      var propInputs = productForm.querySelectorAll('input[name^="properties"]');
      propInputs.forEach(function(input) {
        var match = input.name.match(/properties\[(.+)\]/);
        if (match && input.value) properties[match[1]] = input.value;
      });

      submitBtn.disabled = true;
      submitBtn.classList.add('btn-loading');
      var origText = submitBtn.innerHTML;
      submitBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin"><path d="M12 2v4m0 12v4m-7.07-3.93l2.83-2.83m8.48-8.48l2.83-2.83M2 12h4m12 0h4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83"/></svg> Toevoegen...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId),
          quantity: totalQty,
          properties: properties
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart error ' + res.status);
        return res.json();
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(err) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('btn-loading');
        submitBtn.innerHTML = origText;
        var errorMsg = document.createElement('p');
        errorMsg.className = 'text-sm';
        errorMsg.style.cssText = 'color:var(--red, #e53e3e);margin-top:.5rem;text-align:center';
        errorMsg.textContent = 'Er ging iets mis. Probeer het opnieuw.';
        submitBtn.parentNode.insertBefore(errorMsg, submitBtn.nextSibling);
        setTimeout(function() { errorMsg.remove(); }, 4000);
      });
    });
  }

  if (dateTrigger && calPopupBg) {
    dateTrigger.addEventListener('click', function() {
      initCalendar();
      calPopupBg.classList.add('active');
    });
    calPopupBg.addEventListener('click', function(e) {
      if (e.target === calPopupBg) calPopupBg.classList.remove('active');
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function() {
      var v = parseInt(this.value);
      if (v < 1 || isNaN(v)) { this.value = 1; }
      updatePrice();
    });

    var qtyMinus = document.querySelector('#qty-minus');
    var qtyPlus = document.querySelector('#qty-plus');
    if (qtyMinus) qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
      qtyInput.dispatchEvent(new Event('change'));
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = v + 1;
      qtyInput.dispatchEvent(new Event('change'));
    });
  }

  /* === Close popup === */
  document.querySelectorAll('[data-close-popup]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var p = this.closest('.popup-bg');
      if (p) p.classList.remove('active');
    });
  });

  /* === Coming-soon email signup === */
  document.querySelectorAll('.coming-soon-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = this.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = 'Aangemeld!';
        btn.disabled = true;
        btn.style.background = 'var(--green)';
        btn.style.borderColor = 'var(--green)';
      }
    });
  });

  /* === Filter chips === */
  document.querySelectorAll('.filter-chip').forEach(function(chip) {
    chip.addEventListener('click', function(e) {
      if (this.tagName === 'A') return;
      e.preventDefault();
      document.querySelectorAll('.filter-chip').forEach(function(c) { c.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* === Collection page: Search filter === */
  var collSearch = document.querySelector('#collection-search');
  if (collSearch) {
    collSearch.addEventListener('input', function() {
      var q = this.value.toLowerCase().trim();
      var cards = document.querySelectorAll('.product-grid .product-card');
      cards.forEach(function(card) {
        var title = card.querySelector('.product-card-title');
        if (!title) return;
        card.style.display = title.textContent.toLowerCase().indexOf(q) !== -1 ? '' : 'none';
      });
    });
  }

  /* === Collection page: Show more/less === */
  var showMoreBtn = document.querySelector('#show-more-btn');
  if (showMoreBtn) {
    var grid = showMoreBtn.closest('.collection-main').querySelector('.product-grid');
    var allCards = grid ? grid.querySelectorAll('.product-card') : [];
    var limit = 12;
    var expanded = false;

    function applyShowMore() {
      if (allCards.length <= limit) {
        showMoreBtn.style.display = 'none';
        return;
      }
      for (var i = 0; i < allCards.length; i++) {
        allCards[i].style.display = (!expanded && i >= limit) ? 'none' : '';
      }
      showMoreBtn.textContent = expanded ? 'Toon minder' : 'Toon meer';
    }

    showMoreBtn.addEventListener('click', function() {
      expanded = !expanded;
      applyShowMore();
      if (!expanded) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    applyShowMore();
  }

  /* === Sidebar collapse on mobile === */
  var sidebarToggle = document.querySelector('#sidebar-toggle');
  var sidebarContent = document.querySelector('#sidebar-content');
  if (sidebarToggle && sidebarContent) {
    sidebarToggle.addEventListener('click', function() {
      var isOpen = sidebarContent.style.maxHeight && sidebarContent.style.maxHeight !== '0px';
      sidebarContent.style.maxHeight = isOpen ? '0px' : sidebarContent.scrollHeight + 'px';
      sidebarContent.style.overflow = 'hidden';
      this.setAttribute('aria-expanded', !isOpen);
      this.querySelector('.sidebar-toggle-icon').textContent = isOpen ? '+' : '\u2212';
    });
  }

  /* === Company name invoice notice === */
  var companyInput = document.querySelector('#cart-company');
  var invoiceNotice = document.querySelector('#invoice-notice');
  if (companyInput && invoiceNotice) {
    companyInput.addEventListener('input', function() {
      invoiceNotice.style.display = this.value.trim().length > 0 ? 'flex' : 'none';
    });
  }

  /* === Cookie consent === */
  var cookieBanner = document.querySelector('#cookie-banner');
  var cookieAccept = document.querySelector('#cookie-accept');
  var cookieDecline = document.querySelector('#cookie-decline');

  if (cookieBanner && !localStorage.getItem('ts_cookie_consent')) {
    cookieBanner.style.display = 'flex';
  }

  if (cookieAccept) {
    cookieAccept.addEventListener('click', function() {
      localStorage.setItem('ts_cookie_consent', 'accepted');
      if (cookieBanner) cookieBanner.style.display = 'none';
    });
  }

  if (cookieDecline) {
    cookieDecline.addEventListener('click', function() {
      localStorage.setItem('ts_cookie_consent', 'declined');
      if (cookieBanner) cookieBanner.style.display = 'none';
    });
  }

  /* === Article: Table of Contents generation === */
  var articleContent = document.querySelector('#article-content');
  var tocNav = document.querySelector('#article-toc-nav');
  var tocNavMobile = document.querySelector('#article-toc-nav-mobile');

  if (articleContent && (tocNav || tocNavMobile)) {
    var headings = articleContent.querySelectorAll('h2, h3');
    var tocHtml = '';
    var tocIds = [];

    headings.forEach(function(heading, index) {
      var id = 'section-' + index;
      heading.setAttribute('id', id);
      tocIds.push(id);
      var level = heading.tagName.toLowerCase();
      var cls = level === 'h3' ? ' toc-h3' : '';
      tocHtml += '<a href="#' + id + '" class="toc-link' + cls + '" data-toc-id="' + id + '">' + heading.textContent + '</a>';
    });

    if (tocNav) tocNav.innerHTML = tocHtml;
    if (tocNavMobile) tocNavMobile.innerHTML = tocHtml;

    if (tocIds.length === 0) {
      var tocSidebar = document.querySelector('#article-toc-sidebar .article-toc');
      var tocMobile = document.querySelector('#article-toc-mobile');
      if (tocSidebar) tocSidebar.style.display = 'none';
      if (tocMobile) tocMobile.style.display = 'none';
    }

    /* Scroll spy for TOC active state */
    if (tocIds.length > 0 && 'IntersectionObserver' in window) {
      var activeId = null;
      var tocObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            activeId = entry.target.id;
            document.querySelectorAll('.toc-link').forEach(function(link) {
              link.classList.toggle('active', link.getAttribute('data-toc-id') === activeId);
            });
          }
        });
      }, {
        rootMargin: '-80px 0px -60% 0px',
        threshold: 0
      });

      tocIds.forEach(function(id) {
        var el = document.getElementById(id);
        if (el) tocObserver.observe(el);
      });
    }

    /* Smooth scroll for TOC links */
    document.querySelectorAll('.toc-link').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(this.getAttribute('data-toc-id'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          /* Close mobile TOC */
          var mobileToc = document.querySelector('#article-toc-mobile');
          if (mobileToc && mobileToc.hasAttribute('open')) {
            mobileToc.removeAttribute('open');
          }
        }
      });
    });
  }

  /* === Article: Copy link button === */
  function initCopyLink(btnId) {
    var btn = document.getElementById(btnId);
    if (!btn) return;
    btn.addEventListener('click', function() {
      var url = window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showCopyToast);
      } else {
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        showCopyToast();
      }
    });
  }

  function showCopyToast() {
    var existing = document.querySelector('.copy-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'copy-toast';
    toast.textContent = 'Link gekopieerd!';
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      toast.classList.add('show');
    });
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 300);
    }, 2000);
  }

  initCopyLink('copy-link-btn');
  initCopyLink('copy-link-btn-mobile');

  /* === Category bar mega menu === */
  var catBar = document.querySelector('.cat-bar');
  var catBarItems = document.querySelectorAll('.cat-bar-item');
  var megaOverlay = document.querySelector('.mega-overlay');
  var megaPanels = document.querySelectorAll('.mega-panel');
  var activeCat = null;
  var megaTracking = false;
  var megaRafPending = false;

  function positionMegaPanels() {
    if (!catBar) return;
    var rect = catBar.getBoundingClientRect();
    megaPanels.forEach(function(p) { p.style.top = rect.bottom + 'px'; });
  }

  function openMega(cat) {
    if (activeCat === cat) return;
    var wasOpen = activeCat !== null;
    activeCat = cat;
    positionMegaPanels();

    catBarItems.forEach(function(i) { i.classList.remove('active'); });
    var item = document.querySelector('.cat-bar-item[data-cat="' + cat + '"]');
    if (item) item.classList.add('active');

    megaPanels.forEach(function(p) { p.classList.remove('open'); });
    var panel = document.getElementById('mega-' + cat);
    if (panel) panel.classList.add('open');

    if (megaOverlay) megaOverlay.classList.add('active');
    if (!wasOpen) startMegaTracking();
  }

  function closeAllMega() {
    activeCat = null;
    stopMegaTracking();
    catBarItems.forEach(function(i) { i.classList.remove('active'); });
    megaPanels.forEach(function(p) { p.classList.remove('open'); });
    if (megaOverlay) megaOverlay.classList.remove('active');
  }

  function startMegaTracking() {
    if (megaTracking) return;
    megaTracking = true;
    document.addEventListener('mousemove', onMegaMouseMove, { passive: true });
  }

  function stopMegaTracking() {
    megaTracking = false;
    document.removeEventListener('mousemove', onMegaMouseMove);
  }

  function onMegaMouseMove(e) {
    if (megaRafPending) return;
    megaRafPending = true;
    requestAnimationFrame(function() {
      megaRafPending = false;
      if (!activeCat || !catBar) return;

      var catRect = catBar.getBoundingClientRect();
      var openPanel = document.querySelector('.mega-panel.open');
      var panelRect = openPanel ? openPanel.getBoundingClientRect() : null;

      var zoneTop = catRect.top;
      var zoneBottom = panelRect ? panelRect.bottom + 20 : catRect.bottom;

      if (e.clientY < zoneTop || e.clientY > zoneBottom) {
        closeAllMega();
      }
    });
  }

  catBarItems.forEach(function(item) {
    var cat = item.getAttribute('data-cat');
    if (!cat) return;
    item.addEventListener('mouseenter', function() { openMega(cat); });
  });

  window.addEventListener('scroll', function() {
    if (activeCat) closeAllMega();
  }, { passive: true });

  if (megaOverlay) {
    megaOverlay.addEventListener('click', closeAllMega);
  }

  document.querySelectorAll('.header .logo').forEach(function(logo) {
    logo.addEventListener('click', closeAllMega);
  });

  /* === Klantenservice category switching === */
  var ksNavItems = document.querySelectorAll('.ks-nav-item');
  var ksGroups = document.querySelectorAll('.ks-category-group');

  if (ksNavItems.length > 0) {
    ksNavItems.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cat = this.getAttribute('data-ks-cat');
        ksNavItems.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');
        ksGroups.forEach(function(g) {
          g.classList.toggle('active', g.getAttribute('data-ks-group') === cat);
        });
      });
    });
  }

  /* === Events page calendar === */
  var eventsDateTrigger = document.getElementById('events-date-trigger');
  var eventsCalPopup = document.getElementById('events-cal-popup');
  var eventsCalContainer = document.getElementById('events-cal-container');
  var eventsDateText = document.getElementById('events-date-text');
  var eventDateFrom = document.getElementById('event-date-from');
  var eventDateTo = document.getElementById('event-date-to');

  if (eventsDateTrigger && eventsCalContainer) {
    var evSelectState = { from: null, to: null, step: 'from' };
    var evCalMonth, evCalYear, evMinDate;

    eventsDateTrigger.addEventListener('click', function() {
      var isVisible = eventsCalPopup.style.display !== 'none';
      eventsCalPopup.style.display = isVisible ? 'none' : 'block';
      if (!isVisible) {
        evMinDate = todayCET();
        evCalMonth = evMinDate.getMonth();
        evCalYear = evMinDate.getFullYear();
        renderEventsCalendar();
      }
    });

    function renderEventsCalendar() {
      var firstDay = new Date(evCalYear, evCalMonth, 1);
      var lastDay = new Date(evCalYear, evCalMonth + 1, 0);
      var startWeekday = (firstDay.getDay() + 6) % 7;

      var html = '<div class="cal-header">';
      html += '<button type="button" class="cal-nav ev-cal-prev" aria-label="Vorige maand"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>';
      html += '<span class="cal-title">' + MONTHS_NL[evCalMonth] + ' ' + evCalYear + '</span>';
      html += '<button type="button" class="cal-nav ev-cal-next" aria-label="Volgende maand"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></button>';
      html += '</div>';

      html += '<div class="cal-grid">';
      for (var i = 0; i < 7; i++) {
        html += '<div class="cal-day-name">' + DAYS_NL[i] + '</div>';
      }
      for (var e = 0; e < startWeekday; e++) {
        html += '<div class="cal-cell cal-empty"></div>';
      }
      for (var d = 1; d <= lastDay.getDate(); d++) {
        var thisDate = new Date(evCalYear, evCalMonth, d);
        var iso = dateStr(thisDate);
        var cls = 'cal-cell cal-day';
        var disabled = thisDate < evMinDate;
        if (disabled) cls += ' cal-disabled';
        if (isSameDay(thisDate, todayCET())) cls += ' cal-today';
        if (evSelectState.from && isSameDay(thisDate, evSelectState.from)) cls += ' cal-selected cal-range-start';
        if (evSelectState.to && isSameDay(thisDate, evSelectState.to)) cls += ' cal-selected cal-range-end';
        if (evSelectState.from && evSelectState.to && thisDate > evSelectState.from && thisDate < evSelectState.to) cls += ' cal-in-range';
        html += '<button type="button" class="' + cls + '" data-date="' + iso + '"' + (disabled ? ' disabled' : '') + '>' + d + '</button>';
      }
      html += '</div>';

      html += '<div class="cal-footer">';
      html += '<div class="cal-selection">';
      if (evSelectState.from) {
        html += '<span class="cal-sel-label">Van: <strong>' + formatDateNL(evSelectState.from) + '</strong></span>';
      }
      if (evSelectState.to) {
        var days = daysBetween(evSelectState.from, evSelectState.to);
        html += '<span class="cal-sel-label">Tot: <strong>' + formatDateNL(evSelectState.to) + '</strong></span>';
        html += '<span class="cal-sel-days">' + days + ' ' + (days === 1 ? 'dag' : 'dagen') + '</span>';
      }
      if (!evSelectState.from) {
        html += '<span class="cal-sel-hint">Kies een startdatum</span>';
      } else if (!evSelectState.to) {
        html += '<span class="cal-sel-hint">Kies een einddatum</span>';
      }
      html += '</div>';
      html += '<button type="button" class="btn btn-accent btn-full btn-sm ev-cal-confirm"' + (!evSelectState.from || !evSelectState.to ? ' disabled' : '') + '>Bevestigen</button>';
      html += '</div>';

      eventsCalContainer.innerHTML = html;

      eventsCalContainer.querySelector('.ev-cal-prev').addEventListener('click', function() {
        evCalMonth--;
        if (evCalMonth < 0) { evCalMonth = 11; evCalYear--; }
        renderEventsCalendar();
      });
      eventsCalContainer.querySelector('.ev-cal-next').addEventListener('click', function() {
        evCalMonth++;
        if (evCalMonth > 11) { evCalMonth = 0; evCalYear++; }
        renderEventsCalendar();
      });

      eventsCalContainer.querySelectorAll('.cal-day:not(.cal-disabled)').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var picked = parseDate(this.getAttribute('data-date'));
          if (evSelectState.step === 'from') {
            evSelectState.from = picked;
            evSelectState.to = null;
            evSelectState.step = 'to';
          } else {
            if (picked < evSelectState.from) {
              evSelectState.to = evSelectState.from;
              evSelectState.from = picked;
            } else if (isSameDay(picked, evSelectState.from)) {
              evSelectState.to = picked;
            } else {
              evSelectState.to = picked;
            }
            evSelectState.step = 'from';
          }
          renderEventsCalendar();
        });
      });

      var evConfirmBtn = eventsCalContainer.querySelector('.ev-cal-confirm');
      if (evConfirmBtn) {
        evConfirmBtn.addEventListener('click', function() {
          if (!evSelectState.from || !evSelectState.to) return;
          if (eventDateFrom) eventDateFrom.value = dateStr(evSelectState.from);
          if (eventDateTo) eventDateTo.value = dateStr(evSelectState.to);
          var days = daysBetween(evSelectState.from, evSelectState.to);
          if (eventsDateText) {
            eventsDateText.textContent = formatDateNL(evSelectState.from) + ' — ' + formatDateNL(evSelectState.to) + ' (' + days + ' ' + (days === 1 ? 'dag' : 'dagen') + ')';
          }
          if (eventsDateTrigger) eventsDateTrigger.classList.add('has-value');
          if (eventsCalPopup) eventsCalPopup.style.display = 'none';
        });
      }
    }
  }

  /* === Events form: show success on ?submitted=true === */
  if (window.location.search.indexOf('submitted=true') !== -1) {
    var evLayout = document.querySelector('.events-layout');
    var evHeader = document.querySelector('.events-header');
    var evSuccess = document.getElementById('events-success');
    if (evLayout) evLayout.style.display = 'none';
    if (evHeader) evHeader.style.display = 'none';
    if (evSuccess) evSuccess.style.display = 'block';
  }

  /* === Cart: quantity +/- and remove with AJAX === */
  var cartBusy = false;

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + euros;
  }

  function updateCartSubtotal(totalCents) {
    var subtotalEl = document.querySelector('.cart-subtotal');
    if (subtotalEl && typeof totalCents === 'number') {
      subtotalEl.textContent = formatMoney(totalCents);
      return;
    }
    if (subtotalEl) {
      var total = 0;
      document.querySelectorAll('.cart-item[data-line]').forEach(function(item) {
        var price = parseInt(item.getAttribute('data-item-price')) || 0;
        var qtyInput = item.querySelector('.cart-qty-input');
        var hiddenInput = item.querySelector('input[type="hidden"][name="updates[]"]');
        var qty = qtyInput ? (parseInt(qtyInput.value) || 0) : (hiddenInput ? (parseInt(hiddenInput.value) || 0) : 0);
        total += price * qty;
      });
      subtotalEl.textContent = formatMoney(total);
    }
  }

  function updateLinePrice(cartItem, quantity) {
    var priceEl = cartItem.querySelector('.cart-line-price');
    var unitPrice = parseInt(cartItem.getAttribute('data-item-price')) || 0;
    if (priceEl && unitPrice) {
      priceEl.textContent = formatMoney(unitPrice * quantity);
    }
  }

  function showEmptyCart() {
    var cartForm = document.querySelector('form[action*="cart"]');
    if (!cartForm) return;
    var emptyHTML = '<div class="empty-state" style="margin-top:2rem;text-align:center;padding:2rem 0">'
      + '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--gray-300)" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
      + '<h3 style="margin-top:1rem">Je winkelwagen is leeg</h3>'
      + '<p class="text-sm" style="color:var(--gray-500);margin:.5rem 0 1.5rem">Voeg producten toe om verder te gaan.</p>'
      + '<a href="/collections" class="btn btn-primary">Bekijk assortiment</a>'
      + '</div>';
    cartForm.outerHTML = emptyHTML;
    var upsell = document.querySelector('.upsell-section');
    if (upsell) upsell.remove();
  }

  function removeCartItemDOM(cartItem) {
    cartItem.style.overflow = 'hidden';
    cartItem.style.maxHeight = cartItem.scrollHeight + 'px';
    cartItem.offsetHeight;
    cartItem.style.transition = 'max-height .3s ease, opacity .3s ease, padding .3s ease, margin .3s ease, border .3s ease';
    cartItem.style.maxHeight = '0';
    cartItem.style.opacity = '0';
    cartItem.style.paddingTop = '0';
    cartItem.style.paddingBottom = '0';
    cartItem.style.marginTop = '0';
    cartItem.style.marginBottom = '0';
    cartItem.style.borderColor = 'transparent';
    setTimeout(function() {
      cartItem.remove();
      var remaining = document.querySelectorAll('.cart-item[data-line]');
      if (remaining.length === 0) {
        showEmptyCart();
      } else {
        remaining.forEach(function(el, i) {
          var newLine = i + 1;
          el.setAttribute('data-line', newLine);
          var removeBtn = el.querySelector('.cart-remove-btn');
          if (removeBtn) removeBtn.setAttribute('data-line', newLine);
          var qtyCtrl = el.querySelector('.cart-qty-control');
          if (qtyCtrl) qtyCtrl.setAttribute('data-line', newLine);
        });
      }
      cartBusy = false;
    }, 350);
  }

  function cartUpdate(line, quantity) {
    if (cartBusy) return;
    cartBusy = true;

    var cartItem = document.querySelector('.cart-item[data-line="' + line + '"]');
    if (cartItem) cartItem.classList.add('cart-item-updating');

    var isRemoval = quantity === 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line), quantity: quantity })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart update failed: ' + res.status);
      return res.json();
    })
    .then(function(cart) {
      var hasRealTotal = cart && typeof cart.total_price === 'number' && cart.total_price > 0;
      if (isRemoval && cartItem) {
        removeCartItemDOM(cartItem);
        if (hasRealTotal) {
          updateCartSubtotal(cart.total_price);
        } else {
          setTimeout(function() { updateCartSubtotal(); }, 400);
        }
      } else if (!isRemoval && cartItem) {
        var input = cartItem.querySelector('.cart-qty-input');
        if (input) input.value = quantity;
        updateLinePrice(cartItem, quantity);
        if (hasRealTotal) {
          updateCartSubtotal(cart.total_price);
        } else {
          updateCartSubtotal();
        }
        cartItem.classList.remove('cart-item-updating');
        cartBusy = false;
      } else {
        window.location.reload();
      }
    })
    .catch(function(err) {
      cartBusy = false;
      if (cartItem) cartItem.classList.remove('cart-item-updating');
      var msg = document.createElement('p');
      msg.className = 'text-sm';
      msg.style.cssText = 'color:var(--red, #e53e3e);margin-top:.5rem;text-align:center;padding:.5rem';
      msg.textContent = 'Er ging iets mis. Probeer het opnieuw.';
      if (cartItem) {
        cartItem.parentNode.insertBefore(msg, cartItem.nextSibling);
      } else {
        var form = document.querySelector('form[action*="cart"]');
        if (form) form.prepend(msg);
      }
      setTimeout(function() { msg.remove(); }, 4000);
    });
  }

  document.querySelectorAll('.cart-qty-minus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var control = this.closest('.cart-qty-control');
      var line = control.getAttribute('data-line');
      var input = control.querySelector('.cart-qty-input');
      var current = parseInt(input.value) || 1;
      var newQty = current - 1;
      if (newQty < 0) newQty = 0;
      input.value = newQty;
      cartUpdate(line, newQty);
    });
  });

  document.querySelectorAll('.cart-qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var control = this.closest('.cart-qty-control');
      var line = control.getAttribute('data-line');
      var input = control.querySelector('.cart-qty-input');
      var current = parseInt(input.value) || 1;
      var newQty = current + 1;
      input.value = newQty;
      cartUpdate(line, newQty);
    });
  });

  document.querySelectorAll('.cart-remove-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var line = this.getAttribute('data-line');
      cartUpdate(line, 0);
    });
  });

  /* === Cart: rental date editor calendar === */
  var cartCalPopup = document.querySelector('#cart-date-popup');
  var cartCalContainer = document.querySelector('#cart-cal-container');
  var cartCalState = { from: null, to: null, step: 'from', line: null, variantId: null, stuks: 1, unitPrice: 0, month: 0, year: 0 };

  function openCartCalendar(btn) {
    var fromStr = btn.getAttribute('data-date-from');
    var toStr = btn.getAttribute('data-date-to');
    cartCalState.line = parseInt(btn.getAttribute('data-line'));
    cartCalState.variantId = btn.getAttribute('data-variant-id');
    cartCalState.stuks = parseInt(btn.getAttribute('data-stuks')) || 1;
    cartCalState.unitPrice = parseInt(btn.getAttribute('data-unit-price')) || 0;

    cartCalState.from = fromStr ? parseDate(fromStr) : null;
    cartCalState.to = toStr ? parseDate(toStr) : null;
    cartCalState.step = 'from';

    var now = todayCET();
    cartCalState.month = cartCalState.from ? cartCalState.from.getMonth() : now.getMonth();
    cartCalState.year = cartCalState.from ? cartCalState.from.getFullYear() : now.getFullYear();

    var titleEl = document.querySelector('#cart-cal-title');
    if (titleEl) titleEl.textContent = btn.getAttribute('data-title') || 'Huurperiode wijzigen';

    renderCartCalendar();
    if (cartCalPopup) cartCalPopup.classList.add('active');
  }

  function renderCartCalendar() {
    if (!cartCalContainer) return;
    var minDate = todayCET();
    var cm = cartCalState.month;
    var cy = cartCalState.year;
    var firstDay = new Date(cy, cm, 1);
    var lastDay = new Date(cy, cm + 1, 0);
    var startWeekday = (firstDay.getDay() + 6) % 7;

    var html = '<div class="cal-header">';
    html += '<button type="button" class="cal-nav cart-cal-prev" aria-label="Vorige"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>';
    html += '<span class="cal-title">' + MONTHS_NL[cm] + ' ' + cy + '</span>';
    html += '<button type="button" class="cal-nav cart-cal-next" aria-label="Volgende"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg></button>';
    html += '</div>';

    html += '<div class="cal-grid">';
    for (var i = 0; i < 7; i++) html += '<div class="cal-day-name">' + DAYS_NL[i] + '</div>';
    for (var e = 0; e < startWeekday; e++) html += '<div class="cal-cell cal-empty"></div>';
    for (var d = 1; d <= lastDay.getDate(); d++) {
      var thisDate = new Date(cy, cm, d);
      var iso = dateStr(thisDate);
      var cls = 'cal-cell cal-day';
      var disabled = thisDate < minDate;
      if (disabled) cls += ' cal-disabled';
      if (isSameDay(thisDate, todayCET())) cls += ' cal-today';
      if (cartCalState.from && isSameDay(thisDate, cartCalState.from)) cls += ' cal-selected cal-range-start';
      if (cartCalState.to && isSameDay(thisDate, cartCalState.to)) cls += ' cal-selected cal-range-end';
      if (cartCalState.from && cartCalState.to && thisDate > cartCalState.from && thisDate < cartCalState.to) cls += ' cal-in-range';
      html += '<button type="button" class="' + cls + '" data-date="' + iso + '"' + (disabled ? ' disabled' : '') + '>' + d + '</button>';
    }
    html += '</div>';

    html += '<div class="cal-footer"><div class="cal-selection">';
    if (cartCalState.from) html += '<span class="cal-sel-label">Van: <strong>' + formatDateNL(cartCalState.from) + '</strong></span>';
    if (cartCalState.to) {
      var days = daysBetween(cartCalState.from, cartCalState.to);
      html += '<span class="cal-sel-label">Tot: <strong>' + formatDateNL(cartCalState.to) + '</strong></span>';
      html += '<span class="cal-sel-days">' + days + ' ' + (days === 1 ? 'dag' : 'dagen') + '</span>';
      if (cartCalState.unitPrice > 0) {
        var preview = cartCalState.unitPrice * days * cartCalState.stuks;
        html += '<span class="cal-sel-price">' + days + ' \u00D7 ' + formatMoney(cartCalState.unitPrice);
        if (cartCalState.stuks > 1) html += ' \u00D7 ' + cartCalState.stuks;
        html += ' = ' + formatMoney(preview) + '</span>';
      }
    }
    if (!cartCalState.from) html += '<span class="cal-sel-hint">Kies een startdatum</span>';
    else if (!cartCalState.to) html += '<span class="cal-sel-hint">Kies een einddatum</span>';
    html += '</div>';
    html += '<button type="button" class="btn btn-accent btn-full cart-cal-confirm"' + (!cartCalState.from || !cartCalState.to ? ' disabled' : '') + '>Opslaan</button>';
    html += '</div>';

    cartCalContainer.innerHTML = html;

    cartCalContainer.querySelector('.cart-cal-prev').addEventListener('click', function() {
      cartCalState.month--;
      if (cartCalState.month < 0) { cartCalState.month = 11; cartCalState.year--; }
      renderCartCalendar();
    });
    cartCalContainer.querySelector('.cart-cal-next').addEventListener('click', function() {
      cartCalState.month++;
      if (cartCalState.month > 11) { cartCalState.month = 0; cartCalState.year++; }
      renderCartCalendar();
    });

    cartCalContainer.querySelectorAll('.cal-day:not(.cal-disabled)').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var picked = parseDate(this.getAttribute('data-date'));
        if (cartCalState.step === 'from') {
          cartCalState.from = picked;
          cartCalState.to = null;
          cartCalState.step = 'to';
        } else {
          if (picked < cartCalState.from) {
            cartCalState.to = cartCalState.from;
            cartCalState.from = picked;
          } else if (isSameDay(picked, cartCalState.from)) {
            cartCalState.to = picked;
          } else {
            cartCalState.to = picked;
          }
          cartCalState.step = 'from';
        }
        renderCartCalendar();
      });
    });

    var confirmBtn = cartCalContainer.querySelector('.cart-cal-confirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        if (!cartCalState.from || !cartCalState.to) return;
        confirmBtn.disabled = true;
        confirmBtn.textContent = 'Opslaan...';
        applyRentalChange();
      });
    }
  }

  function applyRentalChange() {
    var days = daysBetween(cartCalState.from, cartCalState.to);
    var totalQty = days * cartCalState.stuks;
    var fromStr = dateStr(cartCalState.from);
    var toStr = dateStr(cartCalState.to);
    var total = cartCalState.unitPrice * days * cartCalState.stuks;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: cartCalState.line, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(cartCalState.variantId),
          quantity: totalQty,
          properties: {
            'Van': fromStr,
            'Tot': toStr,
            'Dagen': days + ' ' + (days === 1 ? 'dag' : 'dagen'),
            'Aantal stuks': String(cartCalState.stuks),
            'Subtotaal': formatMoney(total)
          }
        })
      });
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      window.location.reload();
    })
    .catch(function() {
      window.location.reload();
    });
  }

  document.querySelectorAll('.cart-edit-rental').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openCartCalendar(this);
    });
  });

  if (cartCalPopup) {
    cartCalPopup.addEventListener('click', function(e) {
      if (e.target === cartCalPopup) cartCalPopup.classList.remove('active');
    });
    var closeBtn = cartCalPopup.querySelector('[data-close-cart-cal]');
    if (closeBtn) closeBtn.addEventListener('click', function() {
      cartCalPopup.classList.remove('active');
    });
  }

  /* === Fade-in on scroll (skip already-visible elements to protect LCP) === */
  if ('IntersectionObserver' in window) {
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fade-in').forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < viewH) {
        el.style.opacity = '1';
        return;
      }
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .4s cubic-bezier(.4,0,.2,1), transform .4s cubic-bezier(.4,0,.2,1)';
      obs.observe(el);
    });
  }
})();
